<div class="field-group">
  <mat-form-field><mat-label>Title</mat-label><input [(ngModel)]="composition.title" matInput></mat-form-field>
</div>
<div class="field-group padding-bottom">
  <mat-select *ngIf="isCopy && organisations" (selectionChange)="setOrganisation($event)" placeholder="Select Organisation">
    <mat-option *ngFor="let org of organisations" [value]="org.OrganisationID">{{ org.title }}</mat-option>
  </mat-select>
  <mat-select *ngIf="isCopy && orgCustomers" (selectionChange)="setCustomer($event)" placeholder="Select Customer">
    <mat-option *ngFor="let customer of orgCustomers" [value]="customer._id">{{ customer.organisationName }}</mat-option>
  </mat-select>
</div>

<div *ngFor="let language of availableLanguages; let i = index" class="field-group">
  <mat-checkbox (change)="assignLanguages()" [(ngModel)]="language.checked">{{ language.title }}</mat-checkbox>
  <mat-checkbox (change)="disableLanguages()" [(ngModel)]="availableLanguages[i].disabled" [disabled]="!language.checked">disabled
  </mat-checkbox>
</div>

<div class="field-group padding-top">
  <mat-form-field><mat-label>Master Language</mat-label><input [(ngModel)]="composition.screen.masterLanguage" matInput></mat-form-field>
</div>

<h3>Address</h3>

<div class="field-group-small">
  <mat-form-field><mat-label>Address Title</mat-label><input [(ngModel)]="composition.address.title" matInput></mat-form-field>
  <mat-form-field><mat-label>Street</mat-label><input [(ngModel)]="composition.address.street" matInput></mat-form-field>
  <mat-form-field><mat-label>ZIP</mat-label><input [(ngModel)]="composition.address.zip" matInput type="number"></mat-form-field>
</div>
<div class="field-group-small">
  <mat-form-field><mat-label>City</mat-label><input [(ngModel)]="composition.address.city" matInput></mat-form-field>
  <mat-form-field><mat-label>Phone</mat-label><input [(ngModel)]="composition.address.phone" matInput type="tel"></mat-form-field>
  <mat-form-field><mat-label>Fax</mat-label><input [(ngModel)]="composition.address.fax" matInput></mat-form-field>
</div>
<div class="field-group-small">
  <mat-form-field><mat-label>E-Mail</mat-label><input [(ngModel)]="composition.address.email" matInput type="email"></mat-form-field>
  <mat-form-field><mat-label>Website</mat-label><input [(ngModel)]="composition.address.website" matInput type="url"></mat-form-field>
  <mat-form-field><mat-label>App Title</mat-label><input [(ngModel)]="composition.address.appTitle" matInput></mat-form-field>
</div>

<div class="field-group-small">
  <mat-form-field><mat-label>Latitude</mat-label><input [(ngModel)]="composition.location.coordinates[0]" matInput></mat-form-field>
  <mat-form-field><mat-label>Longitude</mat-label><input [(ngModel)]="composition.location.coordinates[1]" matInput></mat-form-field>
</div>
